import { render } from "./SupportingDocuments.vue?vue&type=template&id=e9bce67c&scoped=true"
import script from "./SupportingDocuments.vue?vue&type=script&lang=js"
export * from "./SupportingDocuments.vue?vue&type=script&lang=js"

import "./SupportingDocuments.vue?vue&type=style&index=0&id=e9bce67c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9bce67c"]])

export default __exports__